jQuery(document).ready(function (jQuery) {
    var heroContent = jQuery(".hero-content-wrapper")
    var heroRow = jQuery(".hero-content")
    var mainContent = jQuery(".main-content")
    heroContent.addClass("hero-load")
    heroRow.addClass("hero-load")
    mainContent.addClass("content-load")
});

//NAV
window.addEventListener('DOMContentLoaded', function () {
    var mobileNavShowing = false;

    jQuery('.mobile-menu-trigger').on('click', function (e) {
        // window.scrollTo(0, 0); //If not fixed header
        if (!mobileNavShowing) {
            mobileNavShowing = true;
            jQuery('.mobile-nav.mobile-only').toggleClass('mobile-open');
            jQuery('.mobile-menu-trigger').toggleClass('menu-active');
            jQuery('.mobile-overlay').toggleClass('active');
            jQuery('.site-header.flex').toggleClass('active');
            jQuery('body').css({
                overflow: 'hidden'
            });
        } else {
            mobileNavShowing = false;
            jQuery('body').css({
                overflow: 'initial'
            });
            jQuery('.mobile-nav.mobile-only').toggleClass('mobile-open');
            jQuery('.mobile-menu-trigger').toggleClass('menu-active');
            jQuery('.mobile-overlay').toggleClass('active');
            jQuery('.site-header.flex').toggleClass('active');
        }
    });

});

jQuery(document).ready(function (jQuery) {
    jQuery('#navMobIcon').on('click', function () {
        jQuery(this).toggleClass('open');
    });
});